import IMAGES from "./images/images";

export const webAppData = [
    {
        id: "0",
        title: "Nike e-commerce webApp ",
        img: IMAGES.nike,
        tools: ["React JS", "Redux","styled-Components","Node JS","mongoDB", "axios", "stripe-js", "JWT"],
        code: "https://github.com/ArcOmotola/e-commerce_app-combined",
        youtube: "https://www.youtube.com/watch?v=R088t41DQPU&t=3s",
        summaryA: "The Nike e-commerce web Application is a full stack web Application I built on the MERN Stack,secured with JWT on the endpoints and integrated with Stripe payment checkout and an admin dashboard for analytics, user and product control and overview. The payment API, while in test mode handles 25 read operations and 25 write operations, similarly. While in live mode, it handles gracefully to a limit of 100 read operations per second, and 100 write operations per second.",
        summaryB: "Overall on the project, I learned responsive design further, writing clean and reusable codes, securing endpoints with JWT,  making API test calls with Postman, handling complex routing, building a Rest API, Redux persistence, integrating stripe, and many more.",
    },

    {
        id: "1",
        title: "Netflix clone",
        img: IMAGES.netflix,
        tools: ["React JS","Redux","CSS","stripe-js", "firebase", "axios"],
        code: "https://github.com/ArcOmotola/netflix-clone",
        youtube: "https://www.youtube.com/watch?v=GQ4OVhfDyoA",
        summaryA: "The NETFLIX clone project is  a quasi NETFLIX-type web Application I built with React, pure CSS, React Youtube, movie-trailer package, Redux, Stripe for subscription handling and firebase to store subscription status. The movie data are fetched from the TMBD API, while the matching trailer video is fetched by the Movie-Trailer package and played on the frontend by React Youtube, but only after a subscription has been made by a user with stripe.",
        summaryB: "On the project, I learned further how to fetch from APIs gracefully, appreciate the importance of Redux and avoid props drilling, especially when accessing User state (initialised or null) before conditionally rendering Home page or register/Login page, integrating stripe subscription, modern UI layout",
    },

    {
        id: "2",
        title: "Chat App",
        img: IMAGES.chatApp,
        tools: ["React JS","CSS","Chat engine API","Socket.io"],
        code: "https://github.com/ArcOmotola/chat_application",
        youtube: "https://www.youtube.com/watch?v=oucvecQNgb4&t=7s",
        summaryA: "The chat application is a primitive Microsoft teams application-type Chat application I built with the Chat Engine API with React JS. From the Chat Engine API Dashboard, Chat rooms are created by an admin, and users are assigned login details, and added to chat rooms.",
        summaryB: "Working on this project, I understood the concept of socket better, conditional rendering, React Hooks, as well as explored the online status feature on the Chat Engine API,  Read receipt feature, image support, sound notifications.",
    },

    {
        id: "3",
        title: "Social Media webApp",
        img: IMAGES.facebook,
        tools: ["React JS","CSS","Context API","mongoDB","axios"],
        code: "https://github.com/ArcOmotola/social-app",
        youtube: "https://www.youtube.com/watch?v=mw74FAES7ss&t=68s",
        summaryA: "The Social Media web application is a Facebook-type clone I built with mongoDB, Express JS, React JS and Node JS. It involved building the backend on Node JS and endpoints to support CRUD operations for various actions on the application, testing the API endpoints each time with PostMan and assembling the FrontEnd with React JS and Context API. I saw the contrasts and similarities between Context API and Redux and why Redux is more suitable for a robust application with multiple changing states.",
        summaryB: "On this project, I learned further how to build a schema with mongoDB and understood better the contrast between the choice of dataTypes in the schema. E.g the followers property would be an Array at its root structure, and not an object because it would be mapped on the frontEnd on the user’s profile friends list, because a map would always return an array, otherwise there’s a property type error thrown.",
    },

    {
        id: "4",
        title: "LinkedIn clone",
        img: IMAGES.linkedIn_clone,
        tools: ["React JS","styled-Components","redux","redux-thunk","firebase"],
        code: "https://github.com/ArcOmotola/Linkedin-clone",
        youtube: "https://www.youtube.com/watch?v=N89qCVqmj_Q",
        summaryA: "The LinkedIn clone webApplication is a Quasi LinkedIn full stack web Application I built with React, Redux, Styled components, Firebase for realtime database, authentication and storage. I worked with the old Redux pattern to get familiar should in case I encounter a legacy or old codebase. Although the comments , share features aren't enabled on this project as the goal was understanding core concepts of building a full stack application, creating the API to handle CRUD operations as well as authentications.",
        summaryB: "In addition, I learned how to build modals, which is simply trigerred by a hook function, understanding the old redux pattern, working with the react Player library to play shared vide content.",
    },

    {
        id: "5",
        title: "Admin dashboard",
        img: IMAGES.adminDash,
        tools: ["React JS","CSS","redux","recharts","axios", "firebase"],
        code: "https://github.com/ArcOmotola/react-admin-dashboard",
        summaryA: "The Admin dashboard web application is an analytics, insight and control dashboard tool I built with React, material UI, and Chart JS which I eventually integrated  with the Nike Full-stack E-commerce web application. The Admin dashboard keeps track of Users, Transaction status, Revenue, Sales and profit, as well as displays a user analytics, product analytics chart and handles CRUD operations for products on the frontend.",
        summaryB: "I learned how to build more complex API endpoints requiring deeper mathematical logic, making aggregates over a certain period and some other intricate Resr API logic. Making API test calls with PostMan while buidling endpoints, working with chart libraries, conditional rendering of transaction status, blue for “pending”, Green for “Approved”, and so much more.",
    },

    {
        id: "6",
        title: "Crypto tracker",
        img: IMAGES.cryptoApp,
        tools: ["React JS","ant design","redux-toolkit-query","axios","chart js"],
        code: "https://github.com/ArcOmotola/crypto-tracker-app",
        youtube: "https://www.youtube.com/watch?v=FTmHJVJGnyg",
        summaryA: "Cryptoverse is a Crypto-Tracker web Application I built with React, Redux Toolkit Query , Ant Design, chart JS, axios and RapidAPI to dynamically fetch various information on up to 100 cryptoCurrencies, as well as their value metrics and price history, and also recent news about each of them.",
        summaryB: "I learned on the project, React best practices for handling requests, by separating requests in a services module or folder rather than fetching locally in same module as component, best practices for importing components, by mounting to a common Index.js file and exporting as a module. It was my first attempt at using Ant design.",
    },

    {
        id: "7",
        title: "Tesla Web App",
        img: IMAGES.teslaImg,
        tools: ["React JS","styled-components","Redux","React Reveal"],
        code: "https://github.com/ArcOmotola/tesla-web-app",
        summaryA: "The Tesla Web App is a web Application I built with React, Redux to imitate the front-End features of the Official Tesla Website. The application features authentication with Firebase, simple animation with React Reveal,  Styled Componenets. Once a user logs in, the application grabs the user’s name from firebase and dynamically displays it on the opening screen as e.g “John’s Tesla”.",
        summaryB: "Among all other things I learned on this project, I understood Firebase authentication better, saw the impotance of passing props to a single component in instances to prevent repetition (DRY-Don’t repeat your Self), clean codes, as well as the use of simple animation features.",
    },

    {
        id: "8",
        title: "Super Mario game",
        img: IMAGES.mario,
        tools: ["HTML","kaboom JS"],
        code: "https://github.com/ArcOmotola/super-mario-game-clone",
        youtube: "https://www.youtube.com/watch?v=4Z_lWauQoJA",
        summaryA: "The Super Mario game application was my introduction to the Kaboom js library and my first game application. The game features some basic two levels of the popular Super Mario Game application, with the motion events, increase sprite or character in size on collision with object for a given period of time, add to score on particular events, end game on chosen events and many more. The game might pass for a preloader on a kid’s application.",
        summaryB: "Working on this project made me really appreciate the works libraries do and how they help speed up development, rather than have one reinvent the wheel. I learned about the Kaboom Js library tools and several functions I would be exploring much later in future projects.",
    },

    {
        id: "9",
        title: "Voice Command News App",
        img: IMAGES.alan,
        tools: ["React JS","Material-ui", "CSS", "Alan-AI", "Alan-sdk-web"],
        code: "https://github.com/ArcOmotola/alan_ai_news_app",
        summaryA: "The Alan-ai New App is an Artificial Intelligence React News Application I built on the Alan AI infrasctructure. Alan AI is a revolutionary speech recognition software that allows you to add voice capabilities to your applications. It allows you to control absolutely everything in the app using your voice.The application takes a number of predefined commands to search various news networks including BBC, CNN, the Guardian, etc for news based on certain category kinds. It also responds to other informal or casual predefined questions.",
        summaryB: "I learned a lot about the Alan AI infrastructre and how to convert voice input to text and neatly craft the text into API requests. One major point on the project was the use of multiple conditionals to capture question kinds, and categorise them with the same response, although a bit manual in contrast with deep learning, but yet very functional.",
    },

    {
        id: "10",
        title: "Covid-19 Tracker",
        img: IMAGES.covid,
        tools: ["React JS","Material-ui", "chart.js", "react-leaflet"],
        code: "https://github.com/ArcOmotola/covid-19_tracker",
        summaryA: "The COVID-19 Tracker web Application is a web Application I built with React, Chart js, react-leaflet and other supporting libraries and dependecies, fetching data from the Disease.sh API. The application typically takes the basic architecture of defaulting to a worldwide state which shows total covid statistics. On change from the dropdown, the state changes and fetches data for that country from the API and displays on the line graph and bubble chart, thereafter it zooms to that country on the map because the coordinates are fetched too. ",
        summaryB: "This was the project where I eventually solidified my understanding of states in react, and how events can be triggered upon a state change. I also developed the practice of using console.table rather than console.log for advanced debugging and for clarity purpose.",
    },

    {
        id: "11",
        title: "Blog Application",
        img: IMAGES.blog,
        tools: ["React JS","CSS", "Context-API", "Node JS", "mongoDB", "Express JS"],
        code: "https://github.com/ArcOmotola/React-Blog-Application",
        summaryA: "The React Blog Application was my first full stack web app project. The Blog application features a minimalist client side design, login, logout, create post, read post, update post, delete post features like a regular blog application. ",
        summaryB: "I got exposed to a lot of full-stack design patterns on this project, the creation of schema and choice of data types, hashing with bcrypt for password hashing on backend storage, building a Rest API and the critical creation of endpoints as well as graceful error handlings, Testing API endpoints with postman, working with mongoDB, and so much more.",
    },

    {
        id: "12",
        title: "Zoom Clone",
        img: IMAGES.zoom,
        tools: ["HTML","CSS", "Socket.io", "Express.js", "EJS", "WebRTC", "PeerJS"],
        code: "https://github.com/ArcOmotola/zoom-clone",
        summaryA: "The ZOOM clone application is a quasi Zoom web Application I built on WebRTC, Express.js, PeerJS. Although not very elaborate, with a login/login experience or personalised space, users join when a room has been created and ask for permission to use audio and video peripherals or ones integrated. Like the regular Zoom application, there’s a chat and reaction section, mute and unmute feature, as well as options to stop recording.",
        summaryB: "This project, in conjuction with the earlier Chat Application I built exposed me better to learning Socket.io technology, which uses a bi-directional communication between web clients and servers.",
    },

    {
        id: "13",
        title: "Who-wants-to-be-a-millionaire",
        img: IMAGES.quiz,
        tools: ["React JS","CSS", "use-sound"],
        code: "https://github.com/ArcOmotola/who-wants-to-be-a-millionaire",
        summaryA: "The WHO-WANTS-TO-BE-A-MILLIONAIRE web Application is a Quiz application I built with original idea and style from the popular TV Quiz series show. Questions are timed and for each right answer at each level, an increment in prize sum. The application adopts the useSound library, attached to react Hooks to trigger a particular sound/music based on a certain state of the application E.G right answer, Wrong Answer.",
        summaryB: "I undertood React Hooks extensively with this application, the typical architecture of how an event of choice could be trigerred based on a certain state of an application.",
    },

    {
        id: "14",
        title: "AirBnb frontEnd Clone",
        img: IMAGES.airBnb,
        tools: ["React JS","CSS", "firebase", "react-date-range"],
        code: "https://github.com/ArcOmotola/airbnb-clone",
        summaryA: "The AirBnb frontend clone is a webApp I built with React, a quasi AirBnb clone, but with focus on the frontend layout, modern UI design, and Firebase hosting introductions. The application is fed with dummy data for the house listings .",
        summaryB: "I learned Modern UI practices, react-date-range library, which seemed a bit tricky initially when I opted to using vanilla Javascript for the date range, which pointed out the importance of working with open Source libraries to hasten and facilitate production.",
    },

    {
        id: "15",
        title: "Crypto price tracker",
        img: IMAGES.cryptoPrice,
        tools: ["React JS","CSS", "axios"],
        code: "https://github.com/ArcOmotola/crypto-search",
        summaryA: "The Crypto price tracker application is a web Application I built with React and Axios, fetching data from the CoinGecko API. The application displays Some basic information about each Crypotocurrency, but with a focus on price performance, as it conditionally renders “red” if in a loss, and “Green” if on a gain.",
        summaryB: "I learned conditional rendering on the project, as well as fetching data from an API with AXIOS and the UseEffect Hook.",
    },
];




export const archiData = [
    {
        id: "0",
        title: "NaijaSweetRice factory",
        cardImg: IMAGES.archi_card1,
        location: "Bida, Niger State",
        date: "2020",
        bigImg: IMAGES.archi_view1,
        slideImgs: [IMAGES.archi_view1, IMAGES.archi_view1_a, IMAGES.archi_view1_b, IMAGES.archi_view1_c, IMAGES.archi_view1_d],
        summary: "Naija SweetRice Factory is a project I designed for The Factory Company Ltd. A major Rice farming, processing and distribution company in Nigeria. The Factory premises consists of the living quarters, office block, Cafetaria, Silo space, warehouses, paddy storage, milling line and other relevant processing facilities.The design aims at achieving a easily accessible Modern Factory complex, with the use of well  defined paths and walkways, representational colour scheme with the brand, as well as plannings for general safety."
    },

    {
        id: "1",
        title: "Creek View Estate",
        cardImg: IMAGES.archi_card2,
        location: "Lekki, Lagos State",
        date: "2020",
        bigImg: IMAGES.archi_view2,
        slideImgs: [IMAGES.archi_view2, IMAGES.archi_view2_a, IMAGES.archi_view2_b , IMAGES.archi_view2_c, IMAGES.archi_view2_d, IMAGES.archi_view2_e, IMAGES.archi_view2_f],
        summary: "Creek-View Estate is a project I designed for a private Contractor in the affluent neighbourhood of Lagos state, with a site area on some 54 land acres.The housing scheme falls into clusters of high density, medium density and low density zones based on affordability and individual buyer's needs. Inclusive of 1 bed, 2bed,3 bed-type, and maisonette units. The estate property features a number of commercial buildings, religious, educational and recreational areas, as well as other supporting facilities."
    },

    {
        id: "2",
        title: "CKCC Chapel",
        cardImg: IMAGES.archi_card3,
        location: "Ijebu-Ode, Ogun State.",
        date: "2019",
        bigImg: IMAGES.archi_view3,
        slideImgs: [ IMAGES.archi_view3, IMAGES.archi_view3_a, IMAGES.archi_view3_b, IMAGES.archi_view3_c, IMAGES.archi_view3_d, IMAGES.archi_view3_e, IMAGES.archi_view3_f, IMAGES.archi_view3_g],
        summary: "Located in the remote town of Odolewu, Ijebu-Ode on the premises of Christ The King Catholic College. The CKCC Chapel is a design contract for my secondary school I won while still an Architecture masters student at the University of Lagos, Akoka. With a sitting capacity of about 1,000, modern finishes with dominant mosaic art at the main entrance and maximally illuminated interior, as well as visual and thermal comfort goals . The design aims at creating a functional, yet timeless and iconic building on the college campus." 
    },

    {
        id: "3",
        title: "ICT Center",
        cardImg: IMAGES.archi_card4,
        location: "Ojodu Berger, Lagos State",
        date: "2021",
        bigImg: IMAGES.archi_view4,
        slideImgs: [IMAGES.archi_view4, IMAGES.archi_view4_a, IMAGES.archi_view4_b, IMAGES.archi_view4_c],
        summary: "Considering the rising trend in tech across the world, the ICT Center in Lagos state is a proposal I prepared for the Lagos State Government.  consisting of an outdoor amphitheater for outdoor tech events, large lush gardens with wifi provisions, and indoor auditorium for large tech summits and seminars, training and research labs and other supporing facilities. the project aims at driving economic development through entrepreneurship, promoting a culture of entrepreneurship, as well as cultivating skills sharing through focused networking."
    },

    {
        id: "4",
        title: "Intermodal Station",
        cardImg: IMAGES.archi_card5,
        location: "Marina, Lagos State",
        date: "2021",
        bigImg: IMAGES.archi_view5,
        slideImgs: [IMAGES.archi_view5, IMAGES.archi_view5_a, IMAGES.archi_view5_b, IMAGES.archi_view5_c, IMAGES.archi_view5_d],
        summary: "The Marina Intermodal station, originally one of my research projects, is a design proposal I prepared for the Lagos state Government to tackle the issues associated with transport and traffic congestion within the state. The goal of the project revolves around providing alternative means of transport by the use of rail system and water ways with the  ferry boat systems, and creating a better organised bus/road transport system by providing a central hub or terminal for handling logistics as well as a base for ingress and egress of people and goods from this station."
    },
];


export const myTools = [
    {
        "softwaredev": {
            id: "1",
            tools: [
                        {"image":IMAGES.icon_react, "link": "https://reactjs.org"},
                        {"image":IMAGES.icon_html, "link": "https://en.wikipedia.org/wiki/HTML"},
                        {"image": IMAGES.icon_css, "link": "https://en.wikipedia.org/wiki/CSS"},
                        {"image": IMAGES.icon_git, "link": "https://git-scm.com/"},
                        {"image": IMAGES.icon_js, "link": "https://en.wikipedia.org/wiki/JavaScript"},
                        {"image": IMAGES.icon_python, "link": "https://www.python.org/"},
                        {"image": IMAGES.icon_firebase, "link": "https://firebase.google.com/"},
                        {"image": IMAGES.icon_linux, "link": "https://www.linux.com/what-is-linux/"},
                        {"image": IMAGES.icon_node, "link": "https://nodejs.org/en/about/"},
                        {"image": IMAGES.icon_mongoDB, "link": "https://www.mongodb.com/what-is-mongodb"},
                        {"image": IMAGES.icon_SQL, "link": "https://en.wikipedia.org/wiki/SQL"},
                        {"image": IMAGES.icon_express, "link": "https://expressjs.com/"},
                    ],
        },
    },

    {
        "architecture": {
            id: "2",
            tools: [
                        {"image": IMAGES.icon_cad, "link": "https://stacbond.com/en/what-is-autocad-and-what-is-it-for/"},
                        {"image": IMAGES.icon_rhino, "link": "https://www.rhino3d.com/"},
                        {"image": IMAGES.icon_lumion, "link": "https://lumion.com/"},
                        {"image": IMAGES.icon_corona, "link": "https://corona-renderer.com/"},
                        {"image": IMAGES.icon_revit, "link": "https://microsolresources.com/tech-resources/article/what-is-revit-used-for/"},
                        {"image": IMAGES.icon_indesign, "link": "https://www.educba.com/what-is-adobe-indesign/"},
                        {"image": IMAGES.icon_illustr, "link": "https://www.educba.com/what-is-adobe-illustrator/"},
                        {"image": IMAGES.icon_vray, "link": "https://www.chaos.com/vray/sketchup/b"},
                        {"image": IMAGES.icon_max, "link": "https://www.autodesk.eu/products/3ds-max/overview?term=1-YEAR&tab=subscription"},
                        {"image": IMAGES.icon_sketchup, "link": "https://www.sketchup.com/"},
                        {"image": IMAGES.icon_ps, "link": "https://www.adobe.com/products/photoshop.html"},
                    ],
        },
    },

    {
        "productDesign": {
            id: "3",
            tools: [    
                        {"image": IMAGES.icon_figma, "link": "https://www.figma.com/"},
                        {"image": IMAGES.icon_indesign, "link":"https://www.educba.com/what-is-adobe-indesign/"},
                        {"image": IMAGES.icon_illustr, "link": "https://www.educba.com/what-is-adobe-illustrator/"},
                        {"image": IMAGES.icon_max, "link": "https://www.autodesk.eu/products/3ds-max/overview?term=1-YEAR&tab=subscription"},
                        {"image": IMAGES.icon_sketchup, "link": "https://www.sketchup.com/"},
                        {"image": IMAGES.icon_ps, "link": "https://www.adobe.com/products/photoshop.html"},
                    ],
        },
    }
]




export const blogdata = [
    {
        id: "1",
        title: "Interacting with GCP services",
        thumbnail: "https://cdn-images-1.medium.com/max/1000/1*xvg0hXdudBnOwY9dabA55w.jpeg",
        pubDate: "2022-01-05 15:51:23",
        link: "https://medium.com/@Omotola_/interacting-with-gcp-services-eb5a1473bb75?source=rss-b9618df5a1a8------2",
        categories: ["gcp","cloud-computing","machine-learning","javascript", "software engineering"],
    },

    {
        id: "2",
        title: "Interacting with GCP services",
        thumbnail: "https://cdn-images-1.medium.com/max/1000/1*xvg0hXdudBnOwY9dabA55w.jpeg",
        pubDate: "2022-01-05 15:51:23",
        link: "https://medium.com/@Omotola_/interacting-with-gcp-services-eb5a1473bb75?source=rss-b9618df5a1a8------2",
        categories: ["gcp","cloud-computing","machine-learning","javascript", "software engineering"],
    },

    {
        id: "3",
        title: "Interacting with GCP services",
        thumbnail: "https://cdn-images-1.medium.com/max/1000/1*xvg0hXdudBnOwY9dabA55w.jpeg",
        pubDate: "2022-01-05 15:51:23",
        link: "https://medium.com/@Omotola_/interacting-with-gcp-services-eb5a1473bb75?source=rss-b9618df5a1a8------2",
        categories: ["gcp","cloud-computing","machine-learning","javascript", "software engineering"],
    },

    {
        id: "4",
        title: "Interacting with GCP services",
        thumbnail: "https://cdn-images-1.medium.com/max/1000/1*xvg0hXdudBnOwY9dabA55w.jpeg",
        pubDate: "2022-01-05 15:51:23",
        link: "https://medium.com/@Omotola_/interacting-with-gcp-services-eb5a1473bb75?source=rss-b9618df5a1a8------2",
        categories: ["gcp","cloud-computing","machine-learning","javascript", "software engineering"],
    },

    {
        id: "5",
        title: "Interacting with GCP services",
        thumbnail: "https://cdn-images-1.medium.com/max/1000/1*xvg0hXdudBnOwY9dabA55w.jpeg",
        pubDate: "2022-01-05 15:51:23",
        link: "https://medium.com/@Omotola_/interacting-with-gcp-services-eb5a1473bb75?source=rss-b9618df5a1a8------2",
        categories: ["gcp","cloud-computing","machine-learning","javascript", "software engineering"],
    },

    {
        id: "6",
        title: "Interacting with GCP services",
        thumbnail: "https://cdn-images-1.medium.com/max/1000/1*xvg0hXdudBnOwY9dabA55w.jpeg",
        pubDate: "2022-01-05 15:51:23",
        link: "https://medium.com/@Omotola_/interacting-with-gcp-services-eb5a1473bb75?source=rss-b9618df5a1a8------2",
        categories: ["gcp","cloud-computing","machine-learning","javascript", "software engineering"],
    },
];





export const spotifyData = [
    {
        id: "1",
        name: "The Google Cloud Platform Podcast",
        img: IMAGES.google_pod,
        link: "https://open.spotify.com/show/36qjuTreaI4bIjd3R9CDXe",
    },

    {
        id: "2",
        name: "WIRED UK Podcast",
        img: IMAGES.wired_pod,
        link: "https://open.spotify.com/show/4lUqFpahx5eB6zuJLKIaJD",
    },

    {
        id: "3",
        name: "TED Talks daily",
        img: IMAGES.ted_pod,
        link: "https://open.spotify.com/show/1VXcH8QHkjRcTCEd88U3ti",
    },

    {
        id: "4",
        name: "The Economist Podcasts",
        img: IMAGES.econs_pod,
        link: "https://open.spotify.com/show/2ZFDmgDS2Z6xccP51s1zFQ",
        
    }
];




export const archiSlider = [
    {
        id: "1",
        img: IMAGES.archi_slide2,
    },

    {
        id: "2",
        img: IMAGES.archi_slide1,
    },

    {
        id: "3",
        img: IMAGES.archi_slide3,
    },

    {
        id: "4",
        img: IMAGES.archi_slide4,
    },

    {
        id: "5",
        img: IMAGES.archi_slide5,
    },

    {
        id: "6",
        img: IMAGES.archi_slide6,
    },

    {
        id: "7",
        img: IMAGES.archi_slide7,
    },

    {
        id: "8",
        img: IMAGES.archi_slide8,
    },

    {
        id: "9",
        img: IMAGES.archi_slide9,
    },

    {
        id: "10",
        img: IMAGES.archi_slide10,
    },

    {
        id: "11",
        img: IMAGES.archi_slide11,
    },
];


export const certSlider = [
    {
        id: "0",
        img: IMAGES.cert_cad,
    },
    {
        id: "1",
        img: IMAGES.cert_git,
    },
    {
        id: "2",
        img: IMAGES.cert_JS,
    },
    {
        id: "3",
        img: IMAGES.cert_cmd,
    },
    {
        id: "4",
        img: IMAGES.cert_web,
    },
]

